import React from "react";
import Coin from "./Coin";

const BettersListCard = ({ bets }) => {
  return (
    <div className="absolute top-100 left-15 w-48 sm:w-64 z-50">
      <div className="bg-white/0 rounded-xl">
        <div className="p-2 sm:p-4">
          {bets && bets.length > 0 ? (
            <div className="betters-scroll-outer max-h-40 sm:max-h-64 overflow-hidden">
              <ul className="space-y-1 sm:space-y-2 betters-scroll-inner">
                {bets.map((bet, i) => (
                  <li
                    key={i}
                    className="flex items-center justify-between p-1 sm:p-2 rounded-lg hover:bg-gray-100 transition"
                  >
                    <span className="font-semibold text-black truncate text-xs sm:text-sm">
                      {bet.username || `Joueur ${i + 1}`}
                    </span>
                    <span className="text-xs sm:text-sm text-green-600 font-semibold flex items-center gap-1">
                      <Coin amount={bet.amount} symbol="HTG" />
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default BettersListCard;
